// extracted by mini-css-extract-plugin
module.exports = {"toggle":"DetailToggle_toggle__2dfxR"};